import React, { useEffect, useRef } from 'react'

import lottie from 'lottie-web/build/player/lottie_light'

import snowAnimation from 'assets/animation/christmasSnowAnimation.json'

import { StyledHolidayBackdrop as S } from './HolidayBackdrop.styles'

const ANIMATION_NAME = 'holiday_backdrop_animation'
export const HolidayBackdrop = () => {
  const animationContainerRef = useRef(null)

  useEffect(() => {
    if (animationContainerRef.current) {
      lottie.loadAnimation({
        name: ANIMATION_NAME,
        container: animationContainerRef.current,
        animationData: snowAnimation,
        loop: true,
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice',
        },
      })
    }

    return () => lottie.destroy(ANIMATION_NAME)
  }, [])
  return (
    <S.Root>
      <S.Wrapper ref={animationContainerRef} />
    </S.Root>
  )
}
